export default class QuestionRelative {
  readonly id: string
  readonly questionId: number
  readonly relativeableType: string
  readonly relativeableId: number
  readonly name: string

  constructor(data: { [key: string]: any }) {
    this.id = data.id
    this.questionId = data.questionId
    this.relativeableType = data.relativeableType
    this.relativeableId = data.relativeableId
    this.name = data.name
  }
}
